var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcDismissSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.52 3.187a.5.5 0 1 0-.707-.707L8 7.293 3.187 2.48a.5.5 0 0 0-.707.707L7.293 8 2.48 12.813a.5.5 0 1 0 .707.707L8 8.707l4.813 4.813a.5.5 0 0 0 .707-.707L8.707 8l4.813-4.813Z",
  fill: "currentColor"
})));
export default SvgIcDismissSearch;